import { render, staticRenderFns } from "./release-preview.vue?vue&type=template&id=ea78718e&scoped=true"
import script from "./release-preview.vue?vue&type=script&lang=js"
export * from "./release-preview.vue?vue&type=script&lang=js"
import style0 from "./release-preview.vue?vue&type=style&index=0&id=ea78718e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea78718e",
  null
  
)

export default component.exports